import React from "react";
import {
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Divider,
  Checkbox,
  FormControlLabel,
  Box,
  Button,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Visibility } from "@mui/icons-material";

// Column Visibility Button — shown next to each table's toolbar
export const ColumnVisibilityButton = ({
  tableType,
  visibleColumns,
  setVisibleColumns,
  toggleColumn,
  columnMenuAnchor,
  activeColumnTable,
  handleColumnMenuOpen,
  handleColumnMenuClose,
  theme,
}) => {
  const columns = visibleColumns[tableType];

  const columnLabels = {
    licenses: {
      license_id: 'License ID',
      uuid: 'System UID',
      project_id: 'Project',
      software_id: 'Software',
      start_date: 'Start Date',
      end_date: 'End Date',
      registered_at: 'Registered',
      status: 'Status',
      actions: 'Actions',
    },
    systems: {
      uuid: 'System UID',
      project_id: 'Project ID',
      software_id: 'Software ID',
      amc: 'AMC Status',
      registered_at: 'Registered',
      actions: 'Actions',
    },
    cameras: {
      id: 'ID',
      uuid: 'System UID',
      project_id: 'Project',
      camera_serial: 'Camera Serial',
      status: 'Status',
      registered_at: 'Registered',
      actions: 'Actions',
    },
  };

  return (
    <>
      <Tooltip title="Customize Columns">
        <IconButton
          size="small"
          onClick={(e) => handleColumnMenuOpen(e, tableType)}
          sx={{
            ml: 1,
            bgcolor: columnMenuAnchor && activeColumnTable === tableType
              ? alpha(theme.palette.primary.main, 0.1)
              : 'transparent',
          }}
        >
          <Visibility />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={columnMenuAnchor}
        open={Boolean(columnMenuAnchor) && activeColumnTable === tableType}
        onClose={handleColumnMenuClose}
        PaperProps={{
          sx: {
            maxHeight: 400,
            width: 220,
            p: 1,
            mt: 1,
          }
        }}
      >
        <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 600 }}>
          Show/Hide Columns
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {Object.keys(columns).map((column) => (
          <MenuItem key={column} sx={{ px: 2, py: 0.5 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={columns[column]}
                  onChange={() => toggleColumn(tableType, column)}
                  size="small"
                  color="primary"
                  disabled={column === 'actions'}
                />
              }
              label={
                <Typography variant="body2">
                  {columnLabels[tableType]?.[column] || column}
                </Typography>
              }
              sx={{ width: '100%' }}
            />
          </MenuItem>
        ))}
        <Divider sx={{ my: 1 }} />
        <Box sx={{ px: 2, py: 1 }}>
          <Button
            fullWidth
            size="small"
            variant="outlined"
            onClick={() => {
              const defaultState = Object.keys(columns).reduce((acc, col) => {
                acc[col] = true;
                return acc;
              }, {});
              setVisibleColumns(prev => ({
                ...prev,
                [tableType]: defaultState
              }));
            }}
          >
            Reset to Default
          </Button>
        </Box>
      </Menu>
    </>
  );
};

export default ColumnVisibilityButton;
